// extracted by mini-css-extract-plugin
export default {"p":"_3cbe39081b ee8c5e5a19 dc88e191a2","clr":"_853d408ae4","dls":"_3c7ab312d8"};